import React, { FC } from 'react'
import { CardItem, AddonData, Periods } from 'types'
import BasketPriceContainer from '../BasketPrice/BasketPriceContainer'
import BasketCard from '../BasketCard/BasketCard'
import BasketAddonCard from '../BasketAddonCard'

interface BasketSummaryProps {
  item: CardItem
  addons: AddonData[]
  prePriceText?: string
  postPriceText?: string
  convertedPricePeriod?: Periods
}

export const BasketSummary: FC<BasketSummaryProps> = ({
  item,
  addons,
  prePriceText,
  postPriceText,
  convertedPricePeriod,
}) => (
  <>
    <h1>Your Basket</h1>
    <BasketCard
      cardImage={item.headerImage}
      title={item.title}
      subtitle={item.subtitle}
    />
    {addons !== undefined && addons.length > 0 && (
      <BasketAddonCard
        selectedAddons={addons}
        convertedPricePeriod={convertedPricePeriod}
      />
    )}
    <BasketPriceContainer
      prePriceText={prePriceText}
      postPriceText={postPriceText}
    />
  </>
)
